<template lang="pug">
  .Progress.box
    .title
      .text
        | {{ title }}
      .info.info-progress
        .info-content
          .percentage(
            :class="'green'"
          )
            span {{ getFormattedAmount(current) }}
            span {{ ' (%' + relativeRatio + ')'}}
    .progress-bar(
      ref="progressBar"
    )
      .indicator(
        :style="{'width': progressRatio + '%'}"
      )
        .progress(:style="{'width': progressBarWidth+'px'}") {{ '% ' + totalRatio }}
      | {{ '% ' + totalRatio }}
    .info-area
      .info
        | Başlangıç:
        span.value {{ getFormattedAmount(start) }}
      .info
        | Beklenen:
        span.value {{ getFormattedAmount(end) }}
        span.ratio {{ ' (%' + ratio + ')'}}

</template>

<script>
  import { roundToTwo } from '@/utils/helper'
  import { formatMoney } from "@/utils/currency"

  export default {
    name: "Progress",

    props: {
      title: {
        default: ''
      },
      start: {
        type: Number,
        default: 0
      },
      current: {
        type: Number,
        default: 0
      },
      ratio: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        progressBarWidth: 0,
      }
    },

    computed: {
      end () {
        let val = this.start * (100 + this.ratio) / 100
        if (this.type === 'price') {
          return roundToTwo(val)
        }
        return Math.ceil(val)
      },

      relativeRatio () {
        let ratio = roundToTwo(((this.current / this.start) - 1) * 100)
        if (!ratio)
          return 0
        return ratio
      },

      totalRatio () {
        let ratio = ((this.current - this.start) / (this.end - this.start)) * 100
        if (!ratio)
          return 0

        return roundToTwo(ratio)
      },


      progressRatio () {
        if (this.totalRatio < 0)
          return 0
        else if (this.totalRatio > 100)
          return 100

        return roundToTwo(this.totalRatio)
      }
    },

    methods: {
      getPriceWithoutDecimal(price) {
        return formatMoney(price).split('.')[0]
      },

      getFormattedAmount(val) {
        if (this.type === 'price') {
          return this.getPriceWithoutDecimal(val)
        } else {
          return val
        }
      }
    },

    mounted () {
      this.$nextTick(() => {
        this.progressBarWidth = this.$refs.progressBar.clientWidth
      })
    }
  }
</script>

<style lang="scss" scoped>
  .Progress {
    width: 100%;
    position: relative;

    .progress-bar {
      position: relative;
      width: 100%;
      height: 24px;
      border-radius: 12px;
      background-color: $color-gray-300;
      text-align: center;

      .indicator {
        background-color: #19AADE;
        position: absolute;
        transition: width .3s;
        left: 0;
        top: 0;
        color: white;
        overflow: hidden;
        height: 100%;
        border-radius: 12px;

        &.complete {
          background-color: $color-green-500;
        }

        &.danger {
          background-color: $color-red-500;
        }
      }
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      .percentage {
        font-weight: 500;
        font-size: 14px;
        margin-top: 2px;

        &.green {
          color: $color-green-500;
        }

        &.red {
          color: $color-red-500;
        }

        &.yellow {
          color: $color-yellow-700;
        }
      }

      .circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 8px;
        align-self: center;
      }

      .desc {
        font-weight: 500;
        align-self: center;
        margin-top: 3px;
        font-size: 14px;
      }
    }

    .info-area {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;

      .info {
        top: 32px;
        right: 0;
        font-weight: 400;
        font-size: 14px;
        color: $color-gray-500;

        .value {
          font-weight: 500;
          color: $color-navy-500;
          font-size: 14px;
          padding-left: 8px;
        }
      }
    }
  }
</style>
